var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/note"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.3335 94.7916H66.6668C79.2502 94.7916 86.4585 87.5833 86.4585 75V34.375C86.4585 21.25 79.7918 14.5833 66.6668 14.5833C64.9585 14.5833 63.5418 16 63.5418 17.7083C63.5418 19.375 62.8752 20.9583 61.7085 22.125C60.5418 23.2916 58.9585 23.9583 57.2918 23.9583H42.7085C39.2502 23.9583 36.4585 21.1666 36.4585 17.7083C36.4585 16 35.0418 14.5833 33.3335 14.5833C20.2085 14.5833 13.5418 21.25 13.5418 34.375V75C13.5418 87.5833 20.7502 94.7916 33.3335 94.7916ZM69.3753 20.9167C75.9586 21.4583 80.2085 24.4166 80.2085 34.375V75C80.2085 84.25 75.9168 88.5416 66.6668 88.5416H33.3335C24.0835 88.5416 19.7918 84.25 19.7918 75V34.375C19.7918 24.4166 24.0417 21.5 30.6251 20.9167C32.0417 26.25 36.9168 30.2083 42.7085 30.2083H57.2918C60.6252 30.2083 63.7501 28.9166 66.1251 26.5416C67.7085 24.9583 68.7919 23.0417 69.3753 20.9167Z",
    fill: "#002C63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.7082 30.2083H57.2915C60.6248 30.2083 63.7498 28.9166 66.1248 26.5416C68.4998 24.1666 69.7915 21.0416 69.7915 17.7083C69.7915 10.8333 64.1665 5.20831 57.2915 5.20831H42.7082C39.3748 5.20831 36.2499 6.5 33.8749 8.875C31.4999 11.25 30.2082 14.375 30.2082 17.7083C30.2082 24.5833 35.8332 30.2083 42.7082 30.2083ZM57.2915 11.4583C60.7498 11.4583 63.5415 14.25 63.5415 17.7083C63.5415 19.375 62.8748 20.9583 61.7082 22.125C60.5415 23.2916 58.9582 23.9583 57.2915 23.9583H42.7082C39.2498 23.9583 36.4582 21.1666 36.4582 17.7083C36.4582 16.0416 37.1249 14.4583 38.2915 13.2917C39.4582 12.125 41.0415 11.4583 42.7082 11.4583H57.2915Z",
    fill: "#002C63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.9998 57.2916H66.6665C68.3748 57.2916 69.7915 55.875 69.7915 54.1666C69.7915 52.4583 68.3748 51.0416 66.6665 51.0416H49.9998C48.2915 51.0416 46.8748 52.4583 46.8748 54.1666C46.8748 55.875 48.2915 57.2916 49.9998 57.2916Z",
    fill: "#002C63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.3332 73.9584H66.6665C68.3748 73.9584 69.7915 72.5417 69.7915 70.8334C69.7915 69.125 68.3748 67.7084 66.6665 67.7084H33.3332C31.6248 67.7084 30.2082 69.125 30.2082 70.8334C30.2082 72.5417 31.6248 73.9584 33.3332 73.9584Z",
    fill: "#002C63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.93ca709a33df2e0ced5ba85b29edffcd.svg";
export { ForwardRef as ReactComponent };